/**
 * Espacio preparado para píxeles de Meta Ads y Google Analytics.
 *
 * Para activarlos:
 * 1. Pega los scripts de Meta Pixel y Google Analytics (GA4) en el <head> del sitio publicado.
 * 2. Estas funciones enviarán los eventos automáticamente cuando los scripts existan.
 */

type TrackableWindow = Window & {
  fbq?: (...args: unknown[]) => void
  gtag?: (...args: unknown[]) => void
}

export function trackEvent(name: string, params: Record<string, unknown> = {}): void {
  if (typeof window === 'undefined') return
  const w = window as TrackableWindow

  // Meta Ads (Pixel)
  w.fbq?.('trackCustom', name, params)

  // Google Analytics (GA4)
  w.gtag?.('event', name, params)
}

export function trackCheckoutIntent(location: string): void {
  trackEvent('InitiateCheckout', {
    content_name: 'LA MUJER QUE OLVIDASTE SER',
    value: 27,
    currency: 'USD',
    location,
  })
}
